class StockImages {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/stock-images`;
    this.apiClient = apiClient;

  }

  async getStockImages(query) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, query);

  }

}

export default StockImages;